import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sales-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sales-features.html',
  styleUrls: ['./sales-features.css'],
})
export class SalesFeaturesComponent {}
